import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {middleEllipsis} from '../../functions/middle-ellipsis';

@Component({
  selector: 'app-copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: ['./copy-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyLinkComponent {
  @Input() value: string;
  @Input() copyValue = '';
  @Input() iconPosition: 'none' | 'right' | 'left' = 'none';
  @Input() showOpenIcon = false;
  @Input() openUrl = '';
  @Input() disabled = false;
  @Input() itemId: string;
  @Input() enableEllipsis: boolean = false;

  @Output() copiedItemId: EventEmitter<string> = new EventEmitter<string>();
  @Output() openTabItemId: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private readonly snackBar: MatSnackBar
  ) {
  }

  public onOpenNewTab(event: MouseEvent): void {
    event.stopPropagation();

    if (this.itemId) {
      this.openTabItemId.emit(this.itemId);
      return;
    }

    window.open(this.openUrl, '_blank');
  }

  public onCopy(event: MouseEvent): void {
    event.stopPropagation();

    if (this.itemId) {
      this.copiedItemId.emit(this.itemId);
      return;
    }

    this.snackBar.open('Copied to clipboard', 'Copy', {duration: 2000, panelClass: 'copy-link'});
  }

  public getDisplayValue(element: HTMLElement): string {
    if (this.enableEllipsis) {
      return middleEllipsis(this.value, element);
    }

    return this.value;
  }
}
